import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  TemplateRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';

export interface ShipmentTrackingCheckpoint {
  status: string;
  completed: boolean;
  icon: string;
  iconClassName?: string;
  templateRef?: TemplateRef<any>;
}

@Component({
  selector: 'twc-shipment-tracking-status',
  imports: [MatIcon, NgTemplateOutlet, NgClass, MatProgressBar],
  templateUrl: './shipment-tracking-status.component.html',
  styleUrl: './shipment-tracking-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentTrackingStatusComponent {
  checkpoints: InputSignal<ShipmentTrackingCheckpoint[]> = input.required();
  progressValue = computed(() => {
    const checkpointsArray = this.checkpoints();
    const totalCheckpoints = checkpointsArray.length;

    let lastCompletedIndex = -1;
    for (let i = totalCheckpoints - 1; i >= 0; i--) {
      if (checkpointsArray[i].completed) {
        lastCompletedIndex = i;
        break;
      }
    }

    if (lastCompletedIndex === -1) return 0;
    if (lastCompletedIndex === totalCheckpoints - 1) return 100;

    const columnWidth = 100 / totalCheckpoints;
    return lastCompletedIndex * columnWidth + columnWidth / 2;
  });
  gridTemplateColumns = computed(
    () => `repeat(${this.checkpoints().length}, 1fr)`
  );
}
